import React, { useEffect, useState } from "react";

import {
  MdGroups,
  MdWork,
  MdHome,
  MdDesignServices,
  MdAccountBalance,
  MdMonetizationOn,
  MdConfirmationNumber,
  MdPendingActions,
  MdMenuBook,
  MdAddCircle,
  MdBusiness,
  MdTimer,
  MdWarning,
  MdAssignment,
  MdShoppingBasket,
  MdAccountBalanceWallet,
  MdChat,
} from "react-icons/md";

import {
  FaDraftingCompass,
  FaFileContract,
  FaLayerGroup,
  FaRegImages,
  FaUsers,
} from "react-icons/fa";
import { MdHelp } from "react-icons/md";

import { useLocation, useNavigate } from "react-router-dom";

import { Menu, Spin } from "antd";
import "./style.css";
import { useAuth } from "../../hooks/AuthContext";
import { TbLetterT, TbUrgent } from "react-icons/tb";
import { RiFileEditLine } from "react-icons/ri";

const MenuOptions = ({ type }) => {
  const navigate = useNavigate();
  const local = useLocation();

  const { signOut, user } = useAuth();

  const [route, setRoute] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    options.map((item, index) => {
      if (item.route == local.pathname) {
        setRoute(`${index}`);
      }
    });
    setTimeout(() => {
      setLoading(false);
    }, 200);
  }, [local]);

  //

  const options = [
    {
      name: "Home",
      route: `/${user.type}/home`,
      visible: true,
      icon: <MdHome size={20} />,
    },
    {
      name: "Minhas OSs",
      route: `/${user.type}/solicitacoes`,
      icon: <MdDesignServices size={20} />,
      visible: true,
      type: "cliente,tecnico",
    },
    {
      name: "Financeiro",
      route: `/${user.type}/financeiro`,
      icon: <MdAccountBalance size={20} />,
      visible: true,
      type: "cliente,tecnico",
    },
    {
      name: "OSs Urgente",
      route: "/admin/orders-urgente",
      icon: <TbUrgent size={20} />,
      visible: true,
      type: "admin",
    },
    {
      name: "Todas OSs",
      route: "/admin/orders",
      icon: <MdAssignment size={20} />,
      visible: true,
      type: "admin",
    },
    {
      name: "Pagamentos",
      route: "/admin/pagamentos",
      visible: true,
      icon: <MdConfirmationNumber size={20} />,
      type: "admin",
    },
    {
      name: "Depositos",
      route: "/admin/depositos",
      visible: true,
      icon: <MdAccountBalance size={20} />,
      type: "admin",
    },
    {
      name: "Cupons de Desconto",
      route: "/admin/cupons",
      visible: true,
      icon: <MdGroups size={20} />,
      type: "admin",
    },
    {
      name: "Área de Marketing",
      route: "/cliente/comprar-lead",
      visible: user.leads_enabled,
      icon: <MdShoppingBasket size={20} />,
      type: "cliente",
    },
    {
      name: "Minha Carteira",
      route: "/cliente/carteira",
      visible: true,
      icon: <MdAccountBalanceWallet size={20} />,
      type: "cliente",
    },
    {
      name: "OSs em Aberto",
      route: "/tecnico/open",
      visible: true,
      icon: <MdPendingActions size={20} />,
      type: "tecnico",
    },
    {
      name: "Solicitar OS",
      route: "/solicitacao",
      visible: true,
      icon: <MdAddCircle size={20} />,
      type: "cliente",
    },
    {
      name: "Área do Conhecimento",
      route: "/courses",
      visible: user.courses_enabled,
      icon: <MdMenuBook size={20} />,
      type: "cliente",
    },
    {
      name: "Técnicos",
      route: "/admin/tecnicos",
      visible: true,
      icon: <FaDraftingCompass size={20} />,
      type: "admin",
    },
    {
      name: "Franqueados",
      route: "/admin/clientes",
      icon: <FaUsers size={20} />,
      visible: true,
      type: "admin",
    },
    {
      name: "Serviços",
      route: "/admin/services",
      icon: <MdWork size={20} />,
      visible: true,
      type: "admin",
    },
    {
      name: "Atendentes",
      route: "/admin/atendentes",
      icon: <FaUsers size={20} />,
      visible: true,
      type: "admin",
    },
    {
      name: "Associados",
      route: "/admin/associados",
      icon: <FaUsers size={20} />,
      visible: true,
      type: "admin",
    },
    {
      name: "Chamados",
      route: "/admin/chamados",
      icon: <MdChat size={20} />,
      visible: true,
      type: "admin",
    },
    {
      name: "Administradores",
      route: "/admin/admins",
      icon: <FaUsers size={20} />,
      visible: true,
      type: "admin",
    },
    {
      name: "Banners",
      route: "/admin/banners",
      icon: <FaRegImages size={20} />,
      visible: true,
      type: "admin",
    },
    {
      name: "Cursos",
      route: "/admin/courses",
      icon: <MdMenuBook size={20} />,
      visible: true,
      type: "admin",
    },
    {
      name: "Contratos",
      route: "/contracts",
      icon: <FaFileContract size={20} />,
      visible: true,
      type: "admin",
    },
    {
      name: "Credenciados",
      route: "/admin/credentials",
      icon: <MdBusiness size={20} />,
      visible: true,
      type: "admin",
    },
    {
      name: "Serviços Guruseg",
      route: "/cliente/servicos",
      visible: true,
      icon: <FaUsers size={20} />,
      type: "cliente",
    },
    {
      name: "Central de Ajuda",
      route: "/cliente/ajuda",
      visible: true,
      icon: <MdHelp size={20} />,
      type: "cliente",
    },
    {
      name: "Contratos",
      route: "/contracts",
      visible: user.leads_enabled,
      icon: <FaFileContract size={20} />,
      type: "cliente",
    },
    {
      name: "CRM",
      route: "/crm",
      visible: user.leads_enabled,
      icon: <FaLayerGroup size={20} />,
      type: "cliente",
    },
    {
      name: "Credenciados",
      route: "/credentials",
      visible: user.credentials_enabled,
      icon: <MdBusiness size={20} />,
      type: "cliente",
    },
    {
      name: "Leads Abertos",
      route: "/admin/leads/send",
      visible: true,
      icon: <FaUsers size={20} />,
      type: "admin",
    },
    {
      name: "Leads Enviados",
      route: "/admin/leads",
      visible: true,
      icon: <FaUsers size={20} />,
      type: "admin",
    },
    {
      name: "Meus Leads",
      route: "/cliente/leads",
      visible: user.leads_enabled,
      icon: <FaUsers size={20} />,
      type: "cliente",
    },
    {
      name: "Lembretes",
      route: "/cliente/reminders",
      visible: true,
      icon: <MdTimer size={20} />,
      type: "cliente",
    },
    {
      name: "Formulário de Levantamento",
      route: "/companies",
      visible: true,
      icon: <RiFileEditLine size={20} />,
      type: "cliente",
    },
    {
      name: "Comunicados",
      route: "/admin/comunicados",
      visible: true,
      icon: <MdWarning size={20} />,
      type: "admin",
    },
    {
      name: "Material de Marketing",
      route:
        "https://starleadsmarketing.notion.site/6c718ab53e4d4fe08eb720bc4151238d?v=0751db8826f040bc85b8d835321dcb27",
      redirect: true,
      visible: user.marketing_enabled,
      icon: <MdMonetizationOn size={20} />,
      type: "cliente",
    },
  ];

  return (
    <>
      <Menu mode="inline" className="menu" selectedKeys={[route]}>
        {options.map((item, index) => {
          if (
            !item.type ||
            (item.type.includes(user.type) && item.visible && !loading)
          ) {
            const itemKey = `${index}`;
            return (
              <Menu.Item
                key={itemKey}
                onClick={() => {
                  setRoute(itemKey);
                  if (item.redirect) {
                    window.open(item.route, "_blank");
                  } else {
                    if (item.route == "/login") {
                      signOut();
                    }
                    navigate(item.route);
                  }
                }}
                className="option"
                icon={item.icon}
              >
                {item.name}
              </Menu.Item>
            );
          }
        })}
      </Menu>
    </>
  );
};

export default MenuOptions;
